/**
 * arFormulaTargetFieldSegments
 *
 * The single write-location rule for a persisted formula result, expressed as
 * LITERAL field-path segments: a plain target lands at
 * `['cells', typeId, 'calcInput']`, a dotted target at
 * `['cells', col, 'value', 'fields', sub, 'value']` (split at the FIRST dot
 * only — the sub-field id keeps any further dots). Segments, not a joined
 * string: Firestore splits an update key on EVERY dot, so a multi-dot target
 * `col.a.b` written as a string nests `fields.a.b` while every reader indexes
 * `fields['a.b']`, and the trigger then rewrites the row forever (SYD-2292).
 * Consumed by reconcileArRow, which wraps them in a `FieldPath`; the exact
 * mirror of readArStoredFormulaResult and applyArFormulaResultsToCells.
 * Literal segments make an arbitrary typeId CHARSET safe, not an arbitrary
 * typeId: `''`, a leading dot and a trailing dot each yield an EMPTY segment,
 * and `new FieldPath()` rejects those synchronously. computeArRowFormulas drops
 * such targets from its results, so no consumer ever builds that path — this
 * function stays total and reports the empty segment rather than hiding it.
 */

function arFormulaTargetFieldSegments(typeId: string): string[] {
  const dotIndex = typeId.indexOf('.');
  if (dotIndex === -1) {
    return ['cells', typeId, 'calcInput'];
  }
  return ['cells', typeId.slice(0, dotIndex), 'value', 'fields', typeId.slice(dotIndex + 1), 'value'];
}

export { arFormulaTargetFieldSegments };
